import { PUBLIC_ROUTES } from './constants/publicRoutes';
import { SERVICE_ROUTES } from './constants/serviceRoutes';
import { EXTERNAL_ROUTES } from './constants/externalRoutes';
import { PRIVATE_ROUTES } from './constants/privateRoutes';

export const ALL_ROUTES = {
  ...SERVICE_ROUTES,
  ...PUBLIC_ROUTES,
  ...PRIVATE_ROUTES,
  ...EXTERNAL_ROUTES,
};

export const ROUTES = Object.values({
  ...SERVICE_ROUTES,
  ...PUBLIC_ROUTES,
  ...EXTERNAL_ROUTES,
  ...flattenObject(PRIVATE_ROUTES, false)
});

export const ALL_PRIVATE_ROUTES = Object.values({
  ...EXTERNAL_ROUTES,
  ...flattenObject(PRIVATE_ROUTES, false)
});

export const ALL_PUBLIC_ROUTES = Object.values({
  ...flattenObject(PUBLIC_ROUTES, true)
});

function flattenObject(obj, stop, parentKey = '', result = {}) {
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    const newKey = parentKey ? `${parentKey}.${key}` : key;
    const value = obj[key];

    if (!stop && typeof value === 'object' && value !== null && !Array.isArray(value)) {
      flattenObject(value, true, newKey, result);
    } else {
      result[newKey] = value;
    }
  }

  return result;
}

export const defaultRoutes = [
  PRIVATE_ROUTES.dashboard.root,
  PRIVATE_ROUTES.account.listDS,
  PRIVATE_ROUTES.patient.list,
];

export const PATIENT_TABLE_NAMES = {
  // Summary tab. Not a table despite living under `:tableName` — the
  // URL segment is the tab identity, and renaming the param would
  // break every existing patient deep link.
  overview: 'overview',
  assessment: 'assessments',
  program: 'programs',
  // Program journeys (the "Programs" tab; `program` above is the legacy
  // Services list, renamed in the UI but not in the code).
  journey: 'journeys',
  resource: 'resources',
  order: 'orders',
  claimsReporting: 'claimsReporting',
  claimReport: 'claimReport',
  reportable: 'reportables',
};
